import React from 'react';
import {useHistory } from 'react-router-dom';
import BreadCrumbs from './BreadCrumbs';
import Footer from './Footer.jsx';
const Faq = () => {

  return (
    // 
    <>
     <BreadCrumbs pageName ="FAQ"/>
     <section className="section-padding">
      <section className="faq-section">
         <div className="container">
            <div className="row">
               <div className="col-md-12">
                  <div className="faq" id="accordion">
                     <div className="card" data-aos="fade-up" data-aos-duration="1000">
                        <div className="card-header" id="faqHeading-1">
                           <div className="mb-0">
                              <h5 className="faq-title" data-toggle="collapse" data-target="#faqCollapse-1" data-aria-expanded="true" data-aria-controls="faqCollapse-1">
                                 <span className="badge">1</span>What is Lorem Ipsum?
                              </h5>
                           </div>
                        </div>
                        <div id="faqCollapse-1" className="collapse" aria-labelledby="faqHeading-1" data-parent="#accordion">
                           <div className="card-body">
                              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                           </div>
                        </div>
                     </div>
                     <div className="card" data-aos="fade-up" data-aos-duration="1200">
                        <div className="card-header" id="faqHeading-2">
                           <div className="mb-0">
                              <h5 className="faq-title" data-toggle="collapse" data-target="#faqCollapse-2" data-aria-expanded="false" data-aria-controls="faqCollapse-2">
                                 <span className="badge">2</span> Where does it come from?
                              </h5>
                           </div>
                        </div>
                        <div id="faqCollapse-2" className="collapse" aria-labelledby="faqHeading-2" data-parent="#accordion">
                           <div className="card-body">
                              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classNameical Latin literature from 45 BC, making it over 2000 years old.</p>
                           </div>
                        </div>
                     </div>
                     <div className="card" data-aos="fade-up" data-aos-duration="1500">
                        <div className="card-header" id="faqHeading-3">
                           <div className="mb-0">
                              <h5 className="faq-title" data-toggle="collapse" data-target="#faqCollapse-3" data-aria-expanded="false" data-aria-controls="faqCollapse-3">
                                 <span className="badge">3</span>Why do we use it?
                              </h5>
                           </div>
                        </div>
                        <div id="faqCollapse-3" className="collapse" aria-labelledby="faqHeading-3" data-parent="#accordion">
                           <div className="card-body">
                              <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here.</p>
                           </div>
                        </div>
                     </div>
                     <div className="card" data-aos="fade-up" data-aos-duration="1800">
                        <div className="card-header" id="faqHeading-4">
                           <div className="mb-0">
                              <h5 className="faq-title" data-toggle="collapse" data-target="#faqCollapse-4" data-aria-expanded="false" data-aria-controls="faqCollapse-4">
                                 <span className="badge">4</span> Where can I get some?
                              </h5>
                           </div>
                        </div>
                        <div id="faqCollapse-4" className="collapse" aria-labelledby="faqHeading-4" data-parent="#accordion">
                           <div className="card-body">
                              <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.</p>
                           </div>
                        </div>
                     </div>
                     <div className="card" data-aos="fade-up" data-aos-duration="2000">
                        <div className="card-header" id="faqHeading-5">
                           <div className="mb-0">
                              <h5 className="faq-title" data-toggle="collapse" data-target="#faqCollapse-5" data-aria-expanded="false" data-aria-controls="faqCollapse-5">
                                 <span className="badge">5</span> What is Lorem Ipsum?
                              </h5>
                           </div>
                        </div>
                        <div id="faqCollapse-5" className="collapse" aria-labelledby="faqHeading-5" data-parent="#accordion">
                           <div className="card-body">
                              <p> It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing</p>
                           </div>
                        </div>
                     </div>
                     <div className="card" data-aos="fade-up" data-aos-duration="2200">
                        <div className="card-header" id="faqHeading-6">
                           <div className="mb-0">
                              <h5 className="faq-title" data-toggle="collapse" data-target="#faqCollapse-6" data-aria-expanded="false" data-aria-controls="faqCollapse-6">
                                 <span className="badge">6</span> Where does it come from?
                              </h5>
                           </div>
                        </div>
                        <div id="faqCollapse-6" className="collapse" aria-labelledby="faqHeading-6" data-parent="#accordion">
                           <div className="card-body">
                              <p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.</p>
                           </div>
                        </div>
                     </div>
                     <div className="card" data-aos="fade-up" data-aos-duration="2500">
                        <div className="card-header" id="faqHeading-7">
                           <div className="mb-0">
                              <h5 className="faq-title" data-toggle="collapse" data-target="#faqCollapse-7" data-aria-expanded="false" data-aria-controls="faqCollapse-7">
                                 <span className="badge">7</span> Why do we use it?
                              </h5>
                           </div>
                        </div>
                        <div id="faqCollapse-7" className="collapse" aria-labelledby="faqHeading-7" data-parent="#accordion">
                           <div className="card-body">
                              <p>Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
    </section>
    <section className="about-cta section-padding">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="cta-content align-row-spacebetween">
                        <div className="content-txt">
                            <h3 className="color-00 pos-relative playfair" data-aos="fade-up" data-aos-duration="2000">Book your next vacation today</h3>
                            <p className="color-00 pt-20" data-aos="fade-up" data-aos-duration="2500">it’s simple just contact with us and one of our team member will assist you how to start.</p>
                        </div>
                        <a href="#" className="btn-default solid-bg-btn pos-relative radius-0" data-aos="fade-up" data-aos-duration="3000"><span>Book Now</span></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Footer/>
    </>
  );
};

export default Faq;
